<template>
    <div class="posterContainer">
      <div class="tapes">
        <div class="tape"></div>
        <div class="tape"></div>
      </div>
      <a
        target="_blank"
        :href="poster.ExternalLink"
        class="poster" 
        :class="{
          active: poster,
          animate: animate
        }"
        :style="{ backgroundImage:`url(${backgroundImage})` }"
      ></a>
    </div>
</template>

<script>
export default {
  name: "Poster",
  props: [
    'poster',
  ],
  mounted() {
    this.backgroundImage = 
      this.$apiURL + this.poster.Poster.formats.small.url
    setInterval(() => {this.animate = !this.animate}, 28000)
  },
  data () {
    return {
      backgroundImage: '',
      animate: false
    }
  },
}
</script>

<style>
.loading .posterContainer {
  height: 0px;
}
.posterContainer {
  /* transform-origin: bottom left;
  transform: skewX(70deg); */
  position: absolute;
  left: 1420px;
  bottom: 200px;
  height: 135px;
  width: 100px;
  display: flex;
  flex-direction: column;
  transition: height 1s ease, opacity 0.2s ease;
  cursor: none;
}

.posterContainer.second {
  left: 1750px;
  top: 300px;
  bottom: unset;
}
.posterContainer.hidden {
  opacity: 0;
}

.posterContainer .tapes {
  width: 80%;
  height: 8px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  z-index: 1;
}
.posterContainer .tapes .tape {
  width: 20px;
  background: rgba(172, 169, 156, 0.623);
}
.posterContainer a.poster {
  margin-top: -4px;
  flex: 1 0 auto;
  cursor: default;
  background-size: cover;
  background-position: center center;
  opacity: 0.8;
  transition: all 0.5s ease;
  transform-origin: top right;
}
.posterContainer a.poster:hover {
  cursor: default;
}
.posterContainer a.poster.active {
  cursor: pointer;
}
.posterContainer a.poster.active:hover {
  filter: drop-shadow(1px 5px 10px rgb(0,0,0,0.3));
  transform: skewX(-2deg);
  opacity: 1;
  transition: all 0.5s ease;
}
.posterContainer a.poster.active.animate {
  animation: 2s ease alternate tugPoster;
}

.posterContainer.second a.poster.active.animate {
  animation: 5s ease alternate tugPoster;
}
@keyframes tugPoster {
  0% {
    filter: none;
    transform: none;
    opacity: 0.8;
  }
  50% {
    filter: drop-shadow(1px 5px 10px rgb(0,0,0,0.3));
    transform: skewX(-2deg);
    opacity: 1;
  }
  0% {
    filter: none;
    transform: none;
    opacity: 0.8;
  }
}

</style>


